// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const spendeFuerDieStiftungFuerKrebskrankeKinderCoburg32DE: PageEntry = {
  id: "post.spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-2",
  locale: "de",
  slug: "spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-2",
  seo: {
    title: "90-jähriges Firmenjubiläum | Dietz GmbH",
    description: "90-jähriges Firmenjubiläum",
  },
  type: "post",
  h1: "90-jähriges Firmenjubiläum",
  blocks: [
    { kind: "heading", level: 2, text: "90-jähriges Firmenjubiläum" },
    { kind: "paragraph", text: "Bayrisch. Fränkisch. Dietz – gemäß diesem Motto zelebrierten wir in diesem Jahr unser 90-jähriges -Firmenjubiläum. An zwei Tage feierten wir gemeinsam mit unseren Kunden, Lieferanten und vielen Ehrengäste sowie unseren Mitarbeitern und deren Familien. Rundum eine gelungene Veranstaltung. Wir danken allen Helfern und Mitwirkenden." }
  ],
};
